import script from "./AliasMixin.vue?vue&type=script&lang=js"
export * from "./AliasMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__